import { render, staticRenderFns } from "./AssessmentBuilderLayoutComponent.vue?vue&type=template&id=4a8c4674&scoped=true&"
import script from "./AssessmentBuilderLayoutComponent.vue?vue&type=script&lang=js&"
export * from "./AssessmentBuilderLayoutComponent.vue?vue&type=script&lang=js&"
import style0 from "./AssessmentBuilderLayoutComponent.vue?vue&type=style&index=0&id=4a8c4674&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a8c4674",
  null
  
)

component.options.__file = "AssessmentBuilderLayoutComponent.vue"
export default component.exports